module.exports = __webpack_public_path__ + "34bc775d/img/verified-icon.f93bbc14.svg";